import CLIENT from '../utils/restClient';
import Logger, {LOG_LEVELS, ALL_MESSAGES} from '../utils/logger';

export const MODULE_NAME = 'MANUAL_DOCUMENTS_CONTROLLER';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

function namespaced(name) {
    return MODULE_NAME+'.'+name;
}
const LOAD_VAT_BOXES = namespaced('LOAD_VAT_BOXES');
const LOAD_VAT_BOXES_OK = namespaced('LOAD_VAT_BOXES_OK');
const LOAD_VAT_BOXES_FAIL = namespaced('LOAD_VAT_BOXES_FAIL');
const UNLOAD_VAT_BOXES = namespaced('UNLOAD_VAT_BOXES');
const CREATE_VAT_BOXES = namespaced('CREATE_VAT_BOXES');
const CREATE_VAT_BOXES_OK = namespaced('CREATE_VAT_BOXES_OK');
const CREATE_VAT_BOXES_FAIL = namespaced('CREATE_VAT_BOXES_FAIL');
const CREATE_MANUAL_DOCUMENT = namespaced('CREATE_MANUAL_DOCUMENT');
const CREATE_MANUAL_DOCUMENT_OK = namespaced('CREATE_MANUAL_DOCUMENT_OK');
const CREATE_MANUAL_DOCUMENT_FAIL = namespaced('CREATE_MANUAL_DOCUMENT_FAIL');
const CREATE_MANUAL_DOCUMENT_RESET_DOCUMENT_DETAILS = namespaced('CREATE_MANUAL_DOCUMENT_RESET_DOCUMENT_DETAILS');

export const ACTION_TYPES = {
    LOAD_VAT_BOXES,
    LOAD_VAT_BOXES_OK,
    LOAD_VAT_BOXES_FAIL,
    UNLOAD_VAT_BOXES,
    CREATE_VAT_BOXES,
    CREATE_VAT_BOXES_OK,
    CREATE_VAT_BOXES_FAIL,
    CREATE_MANUAL_DOCUMENT,
    CREATE_MANUAL_DOCUMENT_OK,
    CREATE_MANUAL_DOCUMENT_FAIL,
    CREATE_MANUAL_DOCUMENT_RESET_DOCUMENT_DETAILS
};

export const updateSubStateFromAction = (state = {data: undefined, loading: false, error: null, uploading: false}, action) => {
    log.debug('updateSubStateFromAction: ', action, state );
    const getNewState = (action, state) => {
      switch (action.type) {
        case LOAD_VAT_BOXES:
          return  Object.assign({}, state, {loading: true, error: null});
        case LOAD_VAT_BOXES_OK:
          return Object.assign({}, state, {vatBoxes: action.response, loading: false, error: null});
        case LOAD_VAT_BOXES_FAIL:
          return Object.assign({}, state, {vatBoxes: undefined, loading: false, error: action.error});
        case CREATE_VAT_BOXES:
          return  Object.assign({}, state, {loading: true, error: null});
        case CREATE_VAT_BOXES_OK:
          return Object.assign({}, state, {createData: action.response, loading: false, error: null});
        case CREATE_VAT_BOXES_FAIL:
          return Object.assign({}, state, {createData: undefined, loading: false, error: action.error});
        case CREATE_MANUAL_DOCUMENT:
          return  Object.assign({}, state, {loading: true, error: null});
        case CREATE_MANUAL_DOCUMENT_OK:
          return Object.assign({}, state, {documentDetails: action.response, loading: false, error: null});
      case CREATE_MANUAL_DOCUMENT_RESET_DOCUMENT_DETAILS:
          return Object.assign({}, state, {documentDetails: undefined, loading: false, error: null});
        case CREATE_MANUAL_DOCUMENT_FAIL:
          return Object.assign({}, state, {documentDetails: undefined, loading: false, error: action.error});
        case UNLOAD_VAT_BOXES:
          return Object.assign({}, state, {vatBoxes: undefined, loading: false, error: undefined});  
        default:
          return state;
      }
    };
    const newState = getNewState(action, state);
    log.debug('updateSubStateFromAction:  newState', newState );
    return newState;
};

export const API = {
    doLoadVATBoxes: (params) => {
      return (dispatch) => {
        dispatch({type: LOAD_VAT_BOXES});
        CLIENT.getVATBoxes(params)
          .then((response) => {
            dispatch({type: LOAD_VAT_BOXES_OK, response: response});
            if(params && typeof params.callback === 'function') {
                params.callback(null, response);
            }
          })
          .catch((error) => {
            dispatch({type: LOAD_VAT_BOXES_FAIL, error});
            if(params && typeof params.callback === 'function') {
                params.callback(error, null);
            }
          });
      };
    },

    clearManualDocumentSuccess() {
      return (dispatch) => {
        log.clearAllDictionaryErrors();
      }
    },

    doCreateManualDocument(params, callback) {
      return (dispatch) => {
        log.clearSuccessMessage(ALL_MESSAGES.CREATE_MANUAL_DOCUMENT_SUCCESS);
        log.clearDictionaryError(ALL_MESSAGES.CREATE_MANUAL_DOCUMENT_NO_FILE_DATA);
        dispatch({type: CREATE_VAT_BOXES});
        CLIENT.createManualDocument(params)
          .then((response) => {
            const uploadDetails = Array.isArray(response) && response.length > 0 ? response[0] : {};
            const fileName = uploadDetails.fileName || 'UNKNOWN_FILENAME';
            dispatch({type: CREATE_VAT_BOXES_OK,  response: Object.assign({}, {fileName: fileName}, response) });
            log.setDictionaryMessage(ALL_MESSAGES.CREATE_MANUAL_DOCUMENT_SUCCESS, fileName);
            if(typeof callback === 'function') {
              callback(null, response);
            }
          })
          .catch((error) => {
            dispatch({type: CREATE_VAT_BOXES_FAIL, error: error});
            if(error && error.status === 400) {
              log.setDictionaryMessage(ALL_MESSAGES.CREATE_MANUAL_DOCUMENT_NO_FILE_DATA);
            }
            if(typeof callback === 'function') {
              callback(error, null);
            }
          });
      };
    },
    doCreateManualDocumentLatest(params, callback) {
        return (dispatch) => {
            log.clearSuccessMessage(ALL_MESSAGES.CREATE_MANUAL_DOCUMENT_SUCCESS);
            log.clearDictionaryError(ALL_MESSAGES.CREATE_MANUAL_DOCUMENT_NO_FILE_DATA);
            dispatch({type: CREATE_MANUAL_DOCUMENT_RESET_DOCUMENT_DETAILS});
            dispatch({type: CREATE_MANUAL_DOCUMENT});
            return CLIENT.createManualDocumentLatest(params)
                .then((response) => {
                    log.debug('doCreateManualDocumentLatest(): success:', response);
                    const uploadDetails = Array.isArray(response) && response.length > 0 ? response : {};
                    dispatch({type: CREATE_MANUAL_DOCUMENT_OK,  response: uploadDetails });
                    if(params.filingType === 1) {
                      const fileName = uploadDetails[0]?.fileName || 'UNKNOWN_FILENAME';
                      dispatch({type: CREATE_VAT_BOXES_OK,  response: Object.assign({}, {fileName: fileName}, response) });
                      log.setDictionaryMessage(ALL_MESSAGES.CREATE_MANUAL_DOCUMENT_SUCCESS, fileName);
                    }
                    if(typeof callback === 'function') {
                      callback(null, response);
                    }
                })
                .catch((error) => {
                    log.debug('doCreateManualDocumentLatest(): error:', error);
                    dispatch({type: CREATE_MANUAL_DOCUMENT_FAIL, error: error});
                    if(error && error.status === 400) {
                        log.setDictionaryMessage(ALL_MESSAGES.CREATE_MANUAL_DOCUMENT_NO_FILE_DATA);
                    }
                    if(typeof callback === 'function') {
                      callback(error, null);
                    }
                });
        };
    },
    doResetDocumentDetails(){
        return (dispatch) => {
            dispatch({type: CREATE_MANUAL_DOCUMENT_RESET_DOCUMENT_DETAILS});
        }
    },
    doUnloadVATBoxes: () => {
        return (dispatch) => {
          dispatch({type: UNLOAD_VAT_BOXES});
        };
    }
};

export default API;
